<template>
    <div>
        <!-- Profile dropdown -->
        <Menu
            v-if="authStore.userData"
            v-slot="{ open }"
            as="div"
            class="relative">
            <MenuButton class="-m-1.5 flex p-1.5 cursor-pointer">
                <span class="sr-only">{{ $t('base.openUserMenu') }}</span>
                <div class="relative">
                    <Icon
                        name="user-circle"
                        size="8"
                        :class="publicArea ? 'text-white' : 'text-gray-400'" />
                    <span
                        v-if="versionMismatch"
                        class="size-2 bg-danger-500 block absolute bottom-0 right-0 rounded-full" />
                </div>
                <span
                    class="hidden lg:flex lg:items-center text-left"
                    :class="publicArea ? 'ml-0' : 'ml-4'">
                    <span v-if="!publicArea">
                        <span
                            class="block text-sm font-semibold leading-none"
                            aria-hidden="true">{{ authStore.userData.fullname }}</span>
                        <span
                            class="leading-none text-sm">
                            {{ authStore.userData.organisation_name }}
                        </span>
                    </span>
                    <Icon
                        name="chevron-down"
                        size="5"
                        class="ml-2 transition-transform duration-150 ease-in-out"
                        :class="{'rotate-180': open, 'text-gray-200': publicArea, 'text-gray-400': !publicArea}"
                        aria-hidden="true" />
                </span>
            </MenuButton>
            <Transition
                enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95">
                <MenuItems
                    class="absolute right-0 z-10 mt-2.5 origin-top-right rounded-md bg-white dark:bg-gray-700 py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                    <div
                        v-if="publicArea"
                        class="px-4 py-2">
                        <span
                            class="block text-sm font-semibold leading-none"
                            aria-hidden="true">{{ authStore.userData.fullname }}</span>
                        <span
                            class="leading-none text-sm">
                            {{ authStore.userData.organisation_name }}
                        </span>
                    </div>
                    <BaseMenuItem
                        v-if="authStore.userData?.organisations?.length > 1"
                        icon="building-office"
                        @click="showChangeOrganisationModal = true">
                        {{ $t('users.changeCurrentOrganisation') }}
                    </BaseMenuItem>
                    <NuxtLink
                        v-if="publicArea"
                        :to="$localePath('/service/dashboard')">
                        <BaseMenuItem
                            icon="home">
                            {{ $t('menu.toManagementArea') }}
                        </BaseMenuItem>
                    </NuxtLink>
                    <NuxtLink
                        :to="$localePath('/service/users/' + authStore.userData.id + '/userBaseData')">
                        <BaseMenuItem
                            icon="user">
                            {{ $t('menu.myProfile') }}
                        </BaseMenuItem>
                    </NuxtLink>
                    <BaseMenuItem
                        icon="information-circle"
                        @click="showUserInfoModal = true">
                        <template #icon>
                            <span class="relative">
                                <Icon
                                    name="information-circle"
                                    size="5" />

                                <span
                                    v-if="versionMismatch"
                                    class="w-2 h-2 bg-danger-500 block absolute bottom-0 right-0 rounded-full" />
                            </span>
                        </template>
                        {{ $t('menu.information') }}
                    </BaseMenuItem>
                    <BaseMenuItem
                        icon="arrow-left-on-rectangle"
                        @click="logout">
                        {{ $t('menu.logout') }}
                    </BaseMenuItem>
                </MenuItems>
            </Transition>
        </Menu>

        <UserInfoModal v-model="showUserInfoModal" />
        <ChangeOrganisationModal v-model="showChangeOrganisationModal" />
    </div>
</template>

<script setup>
import {useAuthStore} from "@/store/auth"

const loading = ref(false)
const authStore = useAuthStore()
const route = useRoute()
const {versionMismatch} = useAppVersion()

const showUserInfoModal = ref(false)
const showChangeOrganisationModal = ref(false)

const logout = async () => {
    loading.value = true
    await authStore.logout()
    loading.value = false
}

const publicArea = computed(() => !route.name.startsWith('service-'))
</script>
